import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    productSearch: '',
    ProductData: [],
    filteredData: [],
    sortBy: null,
    statusFilter: ""
};

const productSlice = createSlice({
    name: "product",
    initialState,
    reducers: {
        setSarchProduct: (state, action) => {
            state.productSearch = action.payload;
        },
        setProductData: (state, action) => {
            state.ProductData = action.payload;
        },
        setFilteredData: (state, action) => {
            state.filteredData = action.payload;
        },
        setSortBy: (state, action) => {
            state.sortBy = action.payload;
        },
        setStatusFilter: (state, action) => {
            state.statusFilter = action.payload;
        },
        resetProductFilter: (state) => {
            state.productSearch = initialState.productSearch;
            state.ProductData = initialState.ProductData;
            state.filteredData = initialState.filteredData;
            state.sortBy = initialState.sortBy;
            state.statusFilter = initialState.statusFilter;
        }
    }
});

export const {
    setSarchProduct,
    setProductData,
    setFilteredData,
    setSortBy,
    setStatusFilter,
    resetProductFilter
} = productSlice.actions

export default productSlice.reducer;